<template>
  <div class="login-page">
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md4>
        <v-card max-width="380" class="mx-auto elevation-6 rounded-lg">
          <v-layout align-center justify-center column class="pt-12 py-4 px-12">
            <img
              src="https://mwu-public-files.s3.us-east-1.amazonaws.com/MWU+Logo.svg"
              alt="MWU Logo"
              class="mwu-logo-image"
              style="width: 280px; height: auto;"
            />
            <div class="cms-label mb-4">CMS</div>
            <div class="subtitle-1">Sign Into Your Account</div>
          </v-layout>
          <div class="pt-1 pa-6">
            <v-form ref="form" @submit.prevent="submit">
              <v-text-field
                autofocus
                outlined
                clearable
                required
                v-model="form.email"
                label="Email or phone number"
                :error-messages="form.$getError('email')"
                data-testid="login-email-input"
              ></v-text-field>
              <v-text-field
                outlined
                required
                type="password"
                label="Password"
                v-model="form.password"
                :error-messages="form.$getError('password')"
                data-testid="login-password-input"
              ></v-text-field>
              <div class="d-flex justify-center">
                <v-btn
                  large
                  color="bg-primary-gradient primary"
                  type="submit"
                  :loading="form.$busy"
                  data-testid="login-submit"
                  class="px-16"
                  >Sign in</v-btn
                >
              </div>
            </v-form>
            <div class="mt-4 text-center">
              <router-link
                :to="{ name: 'auth.forgot-password' }"
                class="grey--text text-decoration-underline"
                >Forgot password ?</router-link
              >
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import Form from '@/utils/form'

export default {
  name: 'LoginPage',

  data() {
    return {
      form: new Form({
        email: null,
        password: null,
      }),
    }
  },

  computed: {
    redirectPath() {
      return Cookies.get('EXPIRED_TOKEN_REDIRECT_PATH')
    },
  },

  methods: {
    submit() {
      this.form.$clearErrors()
      this.form.$busy = true
      this.$api
        .post('auth/check-email', { email: this.form.email })
        .then(() => {
          this.signIn()
        })
        .catch((err) => {
          this.form.$busy = false
          if (err.response.status === 404) {
            this.form.$setErrors({ email: err.response.data.message })
          } else if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    signIn() {
      this.$api
        .post('auth/login', {
          username: this.form.email,
          password: this.form.password,
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$store.commit('auth/setToken', data.data)
          let path = this.redirectPath.startsWith('/auth/')
            ? '/'
            : this.redirectPath

          this.$router.replace({ path })
        })
        .catch((err) => {
          this.form.$busy = false
          if (err.response.status === 401) {
            this.form.$setErrors({ password: err.response.data.message })
          } else if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    },
    'form.password'() {
      this.form.$clearError('password')
    },
  },
}
</script>

<style lang="scss" scoped>
.login-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-image: url('~@/assets/images/login-background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .cms-label {
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: 0.25em;
    color: #555;
  }

  ::v-deep .v-text-field--outlined fieldset {
    border-radius: 10px;
  }
}
</style>
